import React, { ReactNode, useCallback, useState } from 'react';

import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/splide/dist/css/splide-core.min.css';

import { SlideCarouselPage, SlideCarouselPagination, SlideCarouselWrapper } from './styles';

interface Props {
  children: ReactNode;
  onChange?: (newIndex, oldIndex, destIndex) => void;
  options: Record<string, unknown>;
  maxPages?: number;
}

const SlideCarousel = ({
  children,
  onChange,
  className,
  style,
  options,
  maxPages = 7,
}: Props & React.HTMLAttributes<HTMLDivElement>) => {
  const [activePage, setActivePage] = useState(0);

  const onChangeCallback = useCallback(
    (splide, newIndex, oldIndex, destIndex) => {
      setActivePage(newIndex);
      onChange && onChange(newIndex, oldIndex, destIndex);
    },
    [onChange],
  );

  const numOfPages = Math.min(React.Children.count(children), maxPages);
  const diffMaxNumOfPages = React.Children.count(children) - numOfPages;
  const middlePage = Math.floor(numOfPages / 2);
  const activePageWithThreshold =
    activePage > middlePage
      ? activePage <= middlePage + diffMaxNumOfPages
        ? middlePage
        : activePage - diffMaxNumOfPages
      : activePage;

  return (
    <SlideCarouselWrapper className={className} style={style}>
      <Splide onMoved={onChangeCallback} options={{ ...options, pagination: false }}>
        {React.Children.map(children, (child) => (
          <SplideSlide>{child}</SplideSlide>
        ))}
      </Splide>

      <SlideCarouselPagination>
        {[...Array(numOfPages)].map((e, i) => (
          <SlideCarouselPage key={i} $active={i === activePageWithThreshold} />
        ))}
      </SlideCarouselPagination>
    </SlideCarouselWrapper>
  );
};

export default SlideCarousel;
